import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
	0% {
		opacity: 0;
	}
	45%{
    opacity: 0;
  }
  55% {
    opacity:1;
  }
  100% {
		opacity: 1;
	}
`;
/* Animations */

const glitchAnim2 = keyframes`
	0% {
		opacity: 1;
		transform: translate3d(calc(-1 * var(--gap-horizontal)),0,0);
		clip-path: polygon(0 25%, 100% 25%, 100% 40%, 0 40%);
	}
	12% {
		clip-path: polygon(0 3%, 100% 3%, 100% 12%, 0 12%);
	}
	20% {
		clip-path: polygon(0 5%, 100% 5%, 100% 25%, 0 25%);
	}
	28% {
		clip-path: polygon(0 20%, 100% 20%, 100% 35%, 0 35%);
	}
	36% {
		clip-path: polygon(0 40%, 100% 40%, 100% 55%, 0 55%);
	}
	44% {
		clip-path: polygon(0 52%, 100% 52%, 100% 70%, 0 70%);
	}
	52% {
		clip-path: polygon(0 60%, 100% 60%, 100% 80%, 0 80%);
	}
	60% {
		clip-path: polygon(0 75%, 100% 75%, 100% 90%, 0 90%);
	}
	68% {
		clip-path: polygon(0 65%, 100% 65%, 100% 85%, 0 85%);
	}
	76% {
		clip-path: polygon(0 45%, 100% 45%, 100% 65%, 0 65%);
	}
	80% {
		clip-path: polygon(0 14%, 100% 14%, 100% 45%, 0 45%);
	}
	87.6% {
		opacity: 1;
		transform: translate3d(calc(-1 * var(--gap-horizontal)),0,0);
	}
	88%, 100% {
		opacity: 0;
		transform: translate3d(0,0,0);
		clip-path: polygon(0 0, 0 0, 0 0, 0 0);
	}
`;

const glitchAnim3 = keyframes`
	0% {
		opacity: 1;
		transform: translate3d(0, calc(-1 * var(--gap-vertical)), 0) scale3d(-1,-1,1);
		clip-path: polygon(0 1%, 100% 1%, 100% 8%, 0 8%);
	}
	6% {
		clip-path: polygon(0 10%, 100% 10%, 100% 20%, 0 20%);
	}
	8% {
		clip-path: polygon(0 5%, 100% 5%, 100% 15%, 0 15%);
	}
	10% {
		clip-path: polygon(0 20%, 100% 20%, 100% 35%, 0 35%);
	}
	12% {
		clip-path: polygon(0 10%, 100% 10%, 100% 25%, 0 25%);
	}
	20% {
		clip-path: polygon(0 30%, 100% 30%, 100% 45%, 0 45%);
	}
	22% {
		clip-path: polygon(0 15%, 100% 15%, 100% 30%, 0 30%);
	}
	28% {
		clip-path: polygon(0 40%, 100% 40%, 100% 55%, 0 55%);
	}
	32% {
		clip-path: polygon(0 20%, 100% 20%, 100% 35%, 0 35%);
	}
	36% {
		clip-path: polygon(0 60%, 100% 60%, 100% 75%, 0 75%);
	}
	42% {
		clip-path: polygon(0 30%, 100% 30%, 100% 45%, 0 45%);
	}
	44% {
		clip-path: polygon(0 70%, 100% 70%, 100% 85%, 0 85%);
	}
	52% {
		clip-path: polygon(0 40%, 100% 40%, 100% 55%, 0 55%);
	}
	56% {
		clip-path: polygon(0 80%, 100% 80%, 100% 95%, 0 95%);
	}
	58% {
		clip-path: polygon(0 50%, 100% 50%, 100% 65%, 0 65%);
	}
	60% {
		clip-path: polygon(0 90%, 100% 90%, 100% 100%, 0 100%);
	}
	64% {
		clip-path: polygon(0 60%, 100% 60%, 100% 75%, 0 75%);
	}
	72% {
		clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0 100%);
	}
	80% {
		clip-path: polygon(0 70%, 100% 70%, 100% 85%, 0 85%);
	}
	87.6% {
		opacity: 1;
		transform: translate3d(0, calc(-1 * var(--gap-vertical)), 0) scale3d(-1,-1,1);
	}
	88%, 100% {
		opacity: 0;
		transform: translate3d(0,0,0);
		clip-path: polygon(0 0, 0 0, 0 0, 0 0);
	}
`;

const glitchAnimFlash = keyframes`
	0%, 5% {
		opacity: 0.2;
		transform: translate3d(var(--gap-horizontal), var(--gap-vertical), 0);
	}
	22%, 100% {
		opacity: 0;
		transform: translate3d(0, 0, 0);
	}
`;

/* Glitch styles */
const GlitchWrapper = styled.div`
  position: relative;
  width: min-content;
  overflow: hidden;
  > * {
    position: absolute;
    inset: 0;

    &:nth-child(1) {
      animation-duration: 2s;
      animation-name: ${fadeIn};
      position: static;
    }

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5) {
      animation-fill-mode: both;
      animation-duration: 1s;
      animation-delay: var(--delay-anim);
      animation-timing-function: linear;
      animation-iteration-count: 2;
    }

    &:nth-child(2) {
      animation-name: ${glitchAnim2};
    }

    &:nth-child(3) {
      animation-name: ${glitchAnim2};
    }

    &:nth-child(4) {
      animation-name: ${glitchAnim3};
    }

    &:nth-child(5) {
      mix-blend-mode: overlay;
      animation-name: ${glitchAnimFlash};
    }
  }
`;

type Props = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};
export const Glitch = ({ children, className, style }: Props) => {
  return (
    <GlitchWrapper className={className} style={style}>
      <div>{children}</div>
      <div>{children}</div>
      <div>{children}</div>
      <div>{children}</div>
      <div>{children}</div>
    </GlitchWrapper>
  );
};
